// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__iFTDV","clinicsSelect":"styles_clinicsSelect__1xYv1"};